import { EnvironmentId, PrismClientEnvironment, appwriteConfigProduction, urlsProduction } from "@prism/prism-shared";

export const environment: PrismClientEnvironment = {
    environmentId: EnvironmentId.Production,
    urls: urlsProduction,
    appwrite: appwriteConfigProduction,
}
